import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import('../views/Home.vue')
	},
	{
		path: '/iscritto/:id',
		name: 'detail',
		props: true,
		component: () => import('../views/anagrafica/iscritto.vue')
	},
	{
		path: '/iscritto-stp/:id',
		name: 'detailstp',
		props: true,
		component: () => import('../views/anagrafica/stp/iscritto-stp.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
